import React from "react";
import { Pivot, PivotItem, Stack } from "office-ui-fabric-react";
import DynamicForm from "@heartfulnessinstitute/react-hfn-forms/dist/DynamicForm";
import { noop } from "sites-common/utils/lodash";
import { RenderTableData } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/RenderTable";
import { doFormat } from "@heartfulnessinstitute/react-hfn-forms/dist/formatting";
import { TableForm } from "@heartfulnessinstitute/react-hfn-forms/dist/ui/TableForm";
import useMyBoolean from "sites-common/hooks/useMyBoolean";
import { DangerButton, DangerLightButton } from "../../components/Button";
import { useSelector } from "react-redux";
import { selectorSettings } from "../../common1/firebase-selectors/settings";

// import { useBoolean } from "@uifabric/react-hooks";

const renderSingleItemForm = ({
  formFields,
  defaultValues,
  onSubmit,
  onDiscard,
  // namespace,
}) => {
  const { trainer } = useSelector(selectorSettings);

  const [journalEdit, { toggle }] = useMyBoolean(false);

  const newEntryFormFields = formFields.filter((f) => f.name === "sittings")[0]
    .subFormFields;

  const onSave = (newrec, sc = noop, fc = noop) => {
    const postData = newrec;
    postData.trainer = trainer;
    const newValues = {
      ...defaultValues,
      sittings: [postData, ...defaultValues.sittings],
    };
    onSubmit(newValues, sc, fc);
  };
  const markChanges = (defaultValues, updatedValues) =>{
  return updatedValues.map((rec) => {
    const old = defaultValues.find(
      (d) => d.sitting === rec.sitting && d.date === rec.date
    );

    if (!old) {
      return { ...rec, trainer: trainer };
    }
    const isUpdated = Object.keys(rec).some((k) => rec[k] !== old[k]);
    if (isUpdated) {
      return { ...rec, trainer: trainer };
    }
    return rec;
  });
}
  const onSaveEntire = (updatedrec, sc = noop, fc = noop) => {
    const processedRecords = updatedrec;    
    processedRecords.sittings = markChanges(defaultValues.sittings, updatedrec.sittings);
    onSubmit(processedRecords, sc, fc);
  };

  return (
    <Pivot>
      <PivotItem headerText="Add New" itemIcon="Add">
        <DynamicForm
          formFields={newEntryFormFields}
          defaultValues={{}}
          onSubmit={onSave}
          onDiscard={onDiscard}
        />
      </PivotItem>
      <PivotItem headerText="Journal" itemIcon="ThumbnailView">
        {journalEdit ? (
          <TableForm
            formFields={formFields}
            defaultValues={defaultValues}
            onSubmit={onSaveEntire}
            onDiscard={toggle}
          />
        ) : (
          <>
            <RenderTableData
              showHeader
              colDefns={[
                [
                  "Date",
                  (r) => (
                    <div>
                      {doFormat("shortdate", r.date)} <small>{r.sitting}</small>
                    </div>
                  ),
                ],
                ["Notes", "notes"],
                ["Trainer", "trainer"],
              ]}
              rowData={defaultValues.sittings}
            />
            <Stack horizontal horizontalAlign="space-between">
              <DangerButton onClick={onDiscard} text="Close" />
              <DangerLightButton
                iconProps={{ iconName: "Edit" }}
                text="Edit Journal Entries"
                onClick={toggle}
              />
            </Stack>
          </>
        )}
      </PivotItem>
    </Pivot>
  );
};

export default renderSingleItemForm;
